import React, { ReactNode } from "react";

import { IntlShape } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/enum";

import { formatEmailLink } from "@app/util/formatters";
import { getEntityTypeAnalyticsName } from "@app/util/ui";

const getErrorNotificationDescription = (
  intl: IntlShape | undefined,
  entityType: EntityType.COMPANY | EntityType.DEAL | EntityType.PERSON,
  lowercase: boolean = false
) => (
  <div>
    {intl?.formatMessage(
      {
        id: "mapMode.exportFiles.error.description1",
        defaultMessage:
          "There was a problem downloading your {entityType} data. Please try again. If this problem persists, please contact <link>support@mapmycustomers.me</link>.",
        description: "Description shown when download fail",
      },
      {
        entityType: getEntityTypeAnalyticsName(entityType, lowercase, true),

        link: (text: ReactNode) => (
          <a href={formatEmailLink(text as string)} rel="noopener noreferrer" target="_blank">
            {text}
          </a>
        ),
      }
    )}
  </div>
);

export default getErrorNotificationDescription;
